module.exports = __webpack_public_path__ + "static/assets/14ff0e9e964d43617c7298df4b888d10.png";